import * as yup from 'yup';

export const inventoriedInboundStockUpdateFormSchema = (t: any): yup.AnyObjectSchema =>
  yup.object().shape({
    stocks: yup.array().of(
      yup.object().shape({
        weight: yup.lazy(weight => {
          return yup
            .number()
            .transform(value => (isNaN(value) ? undefined : value))
            .required(t('inventoryForm.errors.weight.required'));
        }),
        separationDate: yup.date().when('inventaireCheckbox', {
          is: true,
          then: yup
            .date()
            .typeError(t('inventoryForm.errors.separationDate.required'))
            .required(t('inventoryForm.errors.separationDate.required')),
          otherwise: yup.date().nullable(),
        }),
        separationHour: yup.date().when('inventaireCheckbox', {
          is: true,
          then: yup
            .date()
            .typeError(t('inventoryForm.errors.separationHour.required'))
            .required(t('inventoryForm.errors.separationHour.required')),
          otherwise: yup.date().nullable(),
        }),
      }),
    ),
  });
